// extracted by mini-css-extract-plugin
module.exports = {"root":"_2F6xv","itemClickWrapper":"_1senN","imageZoomBtn":"_1y4so","sizer":"W3iOY","imageWrapper":"_1u_TC","imageBorder":"_3HYWu","image":"hhb-t","overlay":"_2ImpE"};